<p-card header="ISO Graphs">
    <div class="grid" style="margin-top:10px;">
        <div class="col-12">
            <p-card header="Cjun">
                <div *ngIf="loading" class="flex-1 p-4">
                    <p-progressSpinner></p-progressSpinner>
                </div>
                <div *ngIf="!loading">
                    <h4>Raw averages: </h4>
                    <div *ngFor="let average of data.averages">
                        {{average.name}}: {{average.value}}
                    </div><br>
                </div>
                <p-chart *ngIf="!loading" type="line" [data]="data" [options]="options"></p-chart>
            </p-card>
        </div>
    </div>
</p-card>
